export enum TimeSpan {
  lastMonth = 'Last month',
  lastYear = 'Last year',
  thisYear = 'This year',
}

export const spanFilters = [
  { value: TimeSpan.lastYear, label: TimeSpan.lastYear },
  { value: TimeSpan.lastMonth, label: TimeSpan.lastMonth },
  { value: TimeSpan.thisYear, label: TimeSpan.thisYear },
];

export const getDateFrom = (span: TimeSpan): Date => {
  const fromDate = new Date();
  switch (span) {
    case TimeSpan.lastYear:
      fromDate.setFullYear(fromDate.getFullYear() - 1);
      return fromDate;
    case TimeSpan.lastMonth:
      fromDate.setMonth(fromDate.getMonth() - 1);
      return fromDate;
    case TimeSpan.thisYear:
      fromDate.setFullYear(fromDate.getFullYear());
      return fromDate;
    default:
      return fromDate;
      break;
  }
};
